import styled from "styled-components";
import { COLORS } from "../../../../../../styles/constants.style";

export const SearchParticipantsResultWrapper = styled.div`
  .cell {
    min-width: 200px;
  }

  .MuiCheckbox-root {
    padding: 0px;
  }

  .search-result-header-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 20px 16px 16px;
  }

  .search-header-right {
    display: flex;
    justify-content: space-between;
    .search-selected {
      color: ${COLORS.cirrus_black};
    }

    .selected-count {
      color: ${COLORS.cirrus_white};
      background-color: ${COLORS.cirrus_black7};
      padding: 2px 9px 4px 9px;
      border-radius: 7px;
      margin-left: 8px;
      height: 28px;
    }
  }
  .search-result-header {
    color: ${COLORS.cirrus_black10};
  }
`;
